// GENERATED from the v0.9 archive (HenHouse_v0.9.zip) by a one-off port script, then
// maintained by hand. Crow + aura values carried over from v0.9 v2.0.
import type { BreedId, RoosterBreedDef } from './types';

export const ROOSTER_BREEDS: Record<BreedId, RoosterBreedDef> = {
  RIR: {
    id: 'RIR', name: "Rhode Island Red", aura: 1.2, crowPower: 2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'steady_provider', passiveName: "Steady Provider", broodyMod: 1, spriteRow: 0,
    birdFact: "RIR roosters were bred for steady morning behavior — the breed standard explicitly selected against nighttime crowing.",
  },
  LEGHORN: {
    id: 'LEGHORN', name: "White Leghorn", aura: 1.15, crowPower: 4, crowDurationSec: 15, crowCooldownSec: 240,
    passive: 'nervous_energy', passiveName: "Nervous Energy", broodyMod: 1, spriteRow: 1,
    birdFact: "Famously loud. A Leghorn rooster's crow averages 130 dB at 1m — the OSHA limit for unprotected exposure is 85 dB.",
  },
  BUFF_ORPINGTON: {
    id: 'BUFF_ORPINGTON', name: "Buff Orpington", aura: 1.15, crowPower: 1.8, crowDurationSec: 90, crowCooldownSec: 360,
    passive: 'nest_warmth', passiveName: "Nest Warmth", broodyMod: 0.7, spriteRow: 2,
    birdFact: "Among the heaviest show roosters — a BUFF cockerel can hit 10 lb. Cook bred them specifically for broody-hen compatibility in the flock.",
  },
  WYANDOTTE: {
    id: 'WYANDOTTE', name: "Wyandotte", aura: 1.1, crowPower: 1.5, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'silver_eye', passiveName: "Silver Eye", broodyMod: 1, spriteRow: 3,
    birdFact: "Wyandotte roosters were bred to have the rose comb — a ground-hugging comb that resists frostbite in North American winters.",
  },
  AUSTRALORP: {
    id: 'AUSTRALORP', name: "Australorp", aura: 1.3, crowPower: 2.5, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'record_crow', passiveName: "Record Keeper", broodyMod: 1, spriteRow: 4,
    birdFact: "Australian breed registries still treat Australorp and Black Orpington as separate — the Australian line was selected hard for heat tolerance.",
  },
  PLYMOUTH_ROCK: {
    id: 'PLYMOUTH_ROCK', name: "Plymouth Rock", aura: 1.35, crowPower: 1.5, crowDurationSec: 120, crowCooldownSec: 360,
    passive: 'disciplined_flock', passiveName: "Disciplined Flock", broodyMod: 2, spriteRow: 5,
    birdFact: "The WWII \"Victory Chicken\" of America. Roosters were chosen as a Depression-era farm staple because they dressed out at 8 lb with minimal feed.",
  },
  ISA_BROWN: {
    id: 'ISA_BROWN', name: "ISA Brown", aura: 1.25, crowPower: 2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Corporate HR", broodyMod: 1, spriteRow: 6,
    birdFact: "ISA roosters are rarely sold — the hybrid line is maintained by a handful of French and Dutch primary breeders who cull cockerels at hatch.",
  },
  WELSUMMER: {
    id: 'WELSUMMER', name: "Welsummer", aura: 1.15, crowPower: 2, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'dawn_call', passiveName: "Dawn Call", broodyMod: 1, spriteRow: 7,
    birdFact: "Welsummer roosters were selected for the dark-egg trait even though only hens lay. The gene is autosomal — fathers transmit it invisibly.",
  },
  NEW_HAMPSHIRE_RED: {
    id: 'NEW_HAMPSHIRE_RED', name: "New Hampshire Red", aura: 1.2, crowPower: 2.2, crowDurationSec: 50, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Accelerant", broodyMod: 1, spriteRow: 8,
    birdFact: "Bred for the \"fast feathering\" gene — NHR chicks have usable wing feathers within a week, speeding up commercial processing.",
  },
  AMERAUCANA: {
    id: 'AMERAUCANA', name: "Ameraucana", aura: 1.2, crowPower: 2, crowDurationSec: 50, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Azure Crest", broodyMod: 1, spriteRow: 9,
    birdFact: "Unlike the Araucana ancestor, Ameraucana roosters have tails — the Araucana rumpless gene is lethal when homozygous, so the US breeders bred it back in.",
  },
  BLACK_COPPER_MARANS: {
    id: 'BLACK_COPPER_MARANS', name: "Black Copper Marans", aura: 1.1, crowPower: 3, crowDurationSec: 30, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Chocolate Boost", broodyMod: 1, spriteRow: 10,
    birdFact: "French breed from the port of Marans, selected for dark eggs since the 1920s. A cockerel's copper hackles are the breed's name: \"copper feathers on black.\"",
  },
  EASTER_EGGER: {
    id: 'EASTER_EGGER', name: "Easter Egger", aura: 1.2, crowPower: 2.2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Rainbow Call", broodyMod: 1, spriteRow: 11,
    birdFact: "Not recognized by any poultry association — EE roosters are simply any rooster carrying one copy of the blue-egg gene.",
  },
  CREAM_LEGBAR: {
    id: 'CREAM_LEGBAR', name: "Cream Legbar", aura: 1.25, crowPower: 2.3, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Paired Call", broodyMod: 1, spriteRow: 12,
    birdFact: "Punnett's autosexing work means Cream Legbar roosters are visibly different from hens at hatch — a rare trait in chickens.",
  },
  BARNEVELDER: {
    id: 'BARNEVELDER', name: "Barnevelder", aura: 1.3, crowPower: 2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Collector's Pride", broodyMod: 1, spriteRow: 13,
    birdFact: "Dutch breed named for Barneveld. Rooster hackles are the subject of a 100-page feather-pattern breed standard published by the KLN.",
  },
  SILKIE: {
    id: 'SILKIE', name: "Silkie", aura: 1.2, crowPower: 1.8, crowDurationSec: 90, crowCooldownSec: 360,
    passive: 'silk_brooder', passiveName: "Silk Brooder", broodyMod: 0.6, spriteRow: 14,
    birdFact: "Chinese traditional medicine prizes black-bone Silkies for soup; male birds are preferred in that application. Roosters carry the same silk-feather mutation.",
  },
  BIELEFELDER: {
    id: 'BIELEFELDER', name: "Bielefelder", aura: 1.35, crowPower: 2, crowDurationSec: 75, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Gentle Giant", broodyMod: 1, spriteRow: 15,
    birdFact: "Bielefelder roosters are a distinctive red-brown with black hackle barring. Selected for extreme docility — bred to not flog keepers.",
  },
  SVART_HONA: {
    id: 'SVART_HONA', name: "Svart Hona", aura: 1.3, crowPower: 2.5, crowDurationSec: 45, crowCooldownSec: 360,
    passive: 'aura_only', passiveName: "Dark Heritage", broodyMod: 1, spriteRow: 16,
    birdFact: "All black, down to the comb and wattle. Roosters retain the fibromelanosis gene and pass it reliably to both sexes of offspring.",
  },
  OLIVE_EGGER: {
    id: 'OLIVE_EGGER', name: "Olive Egger", aura: 1.2, crowPower: 2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Olive Grove", broodyMod: 1, spriteRow: 17,
    birdFact: "OE roosters have no visible marker for the blue-egg gene they carry — breeders must test-mate to confirm.",
  },
  SPECKLED_SUSSEX: {
    id: 'SPECKLED_SUSSEX', name: "Speckled Sussex", aura: 1.25, crowPower: 2, crowDurationSec: 70, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Old Guard", broodyMod: 1, spriteRow: 18,
    birdFact: "The Sussex rooster standard describes 12 distinct speckle patterns, all considered faulty in show birds; commercial stock ignores them entirely.",
  },
  AYAM_CEMANI: {
    id: 'AYAM_CEMANI', name: "Ayam Cemani", aura: 2, crowPower: 5, crowDurationSec: 30, crowCooldownSec: 420,
    passive: 'aura_only', passiveName: "Midnight Frenzy", broodyMod: 1, spriteRow: 19,
    birdFact: "Traditionally believed to carry spiritual significance in Javanese culture. Roosters were used in ritual offerings well into the 20th century.",
  },
  POLISH: {
    id: 'POLISH', name: "Polish", aura: 1.25, crowPower: 3.5, crowDurationSec: 30, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Polish Flair", broodyMod: 1, spriteRow: 20,
    birdFact: "The crested gene reduces skull size — crested roosters have measurably less brain volume than non-crested chickens. They seem fine.",
  },
  FRIZZLE: {
    id: 'FRIZZLE', name: "Frizzle", aura: 1.2, crowPower: 2.5, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Frizzled Fortune", broodyMod: 1, spriteRow: 21,
    birdFact: "Homozygous frizzled roosters are almost always culled in breeding programs because of brittle-feather welfare issues.",
  },
  TURKEN: {
    id: 'TURKEN', name: "Turken", aura: 1.3, crowPower: 2.2, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Nothing to Hide", broodyMod: 1, spriteRow: 22,
    birdFact: "Transylvanian Naked Neck roosters are wildly temperature-tolerant — bare skin on the neck is a thermoregulation adaptation.",
  },
  SULTAN: {
    id: 'SULTAN', name: "Sultan", aura: 1.5, crowPower: 2.5, crowDurationSec: 60, crowCooldownSec: 420,
    passive: 'aura_only', passiveName: "Royal Decree", broodyMod: 1, spriteRow: 23,
    birdFact: "The Sultan cockerel's beard, vulture hocks, crest, and muffs are all separate dominant genes — reassembling them nearly lost the breed in the 1950s.",
  },
  DONG_TAO: {
    id: 'DONG_TAO', name: "Dong Tao", aura: 1.3, crowPower: 2.5, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Heavy Foot", broodyMod: 1, spriteRow: 24,
    birdFact: "Vietnamese legend holds that Dong Tao feet were once tribute to Vietnamese emperors — one pair of legs could feed a courtier for a week.",
  },
  BRAHMA: {
    id: 'BRAHMA', name: "Brahma", aura: 1.4, crowPower: 2, crowDurationSec: 80, crowCooldownSec: 360,
    passive: 'aura_only', passiveName: "Brahma Majesty", broodyMod: 1, spriteRow: 25,
    birdFact: "A good-sized Brahma rooster stands 30 inches at the shoulder — taller than a miniature poodle.",
  },
  COCHIN: {
    id: 'COCHIN', name: "Cochin", aura: 1.2, crowPower: 1.8, crowDurationSec: 90, crowCooldownSec: 300,
    passive: 'warmth_call', passiveName: "Warmth Aura", broodyMod: 0.5, spriteRow: 26,
    birdFact: "The original 1843 Cochin imports from China were sketched by Queen Victoria personally — her drawings hang in the Royal Archives.",
  },
  SERAMA: {
    id: 'SERAMA', name: "Serama", aura: 1.3, crowPower: 3, crowDurationSec: 30, crowCooldownSec: 240,
    passive: 'aura_only', passiveName: "Big Energy", broodyMod: 1, spriteRow: 27,
    birdFact: "The Serama cockerel's \"posing\" behavior — chest out, head back — is genetic, not trained. Chicks do it by day 3.",
  },
  JAPANESE_BANTAM: {
    id: 'JAPANESE_BANTAM', name: "Japanese Bantam", aura: 1.35, crowPower: 2.3, crowDurationSec: 45, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Bantam Stance", broodyMod: 1, spriteRow: 28,
    birdFact: "Chabo cockerels have always been bred shorter than their hens — the selective pressure ran opposite to almost every other breed.",
  },
  SEBRIGHT: {
    id: 'SEBRIGHT', name: "Sebright", aura: 1.35, crowPower: 2.5, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'aura_only', passiveName: "Chain Mail", broodyMod: 1, spriteRow: 29,
    birdFact: "Sebright roosters are \"hen-feathered\" — they lack the normal rooster tail plume, which is why Darwin cited them in his breeding studies.",
  },
  MILLE_FLEUR_DUCCLE: {
    id: 'MILLE_FLEUR_DUCCLE', name: "Mille Fleur D'Uccle", aura: 1.3, crowPower: 2.3, crowDurationSec: 60, crowCooldownSec: 300,
    passive: 'bloom_call', passiveName: "Thousand Flowers", broodyMod: 1, spriteRow: 30,
    birdFact: "Belgian bantam, created in the 19th century by Michel Van Gelder. The \"D'Uccle\" is the village of Uccle near Brussels.",
  },
};
